import { render, staticRenderFns } from "./SetupSalaryMechanism.vue?vue&type=template&id=542a4f52"
import script from "./SetupSalaryMechanism.vue?vue&type=script&lang=js"
export * from "./SetupSalaryMechanism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports